// extracted by mini-css-extract-plugin
export default {"container":"Vl-z","blurb":"Wl-z","links":"Xl-z"};